import "./bootstrap";

import Vue from "vue";
import store from "./store";
import components from "./register-components";

Object.entries(components).forEach(([name, component]) => {
    Vue.component(name, component);
});

new Vue({
    store,
}).$mount("#app");
